// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"e45a615f","226":"a830ba45","257":"3b2b41d4","704":"b4c53727","913":"1682360f","945":"564ca2e4","977":"421e4c48"}[chunkId] + ".chunk.css";
};